import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import SchoolCardResultsComponent from "src/components/user/results-school-card-component";
import { schoolMockData } from "src/services/school-mock-data/school-mock-data";

function SchoolCardResultsContainer() {
  const { i18n, t } = useTranslation();
  const dummyData = schoolMockData;
  const [filtered, setFiltered] = useState(dummyData);
  const searchValues = useParams();

  const handleSearchSchools = () => {
    if (
      searchValues.country === ":country" &&
      searchValues.edusystem === ":edusystem" &&
      searchValues.edulevel === ":edulevel"
    ) {
      setFiltered(dummyData);
      return;
    }
    if (
      searchValues.country === "كل المدن" &&
      searchValues.edusystem === "كل الأنظمة" &&
      searchValues.edulevel === "كل المراحل"
    ) {
      const filterBySearch = dummyData.filter((item) => {
        return (
          item.educationLevel.includes(searchValues.edulevel!) ||
          item.educationSystem.includes(searchValues.edusystem!)
        );
      });
      setFiltered(filterBySearch);
    }
    if (
      searchValues.country === "كل المدن" &&
      searchValues.edusystem !== "كل الأنظمة" &&
      searchValues.edulevel !== "كل المراحل"
    ) {
      const filterBySearch = dummyData.filter((item) => {
        return (
          item.city.includes(searchValues.country!) ||
          item.educationLevel.includes(searchValues.edulevel!) ||
          item.educationSystem.includes(searchValues.edusystem!)
        );
      });
      setFiltered(filterBySearch);
    }
    if (
      searchValues.edusystem === "كل الأنظمة" &&
      searchValues.country !== "كل المدن" &&
      searchValues.edulevel !== "كل المراحل"
    ) {
      const filterBySearch = dummyData.filter((item) => {
        return (
          item.city.includes(searchValues.country!) ||
          item.educationLevel.includes(searchValues.edulevel!)
        );
      });
      setFiltered(filterBySearch);
    }
    if (
      searchValues.edulevel === "كل المراحل" &&
      searchValues.edusystem !== "كل الأنظمة" &&
      searchValues.country !== "كل المدن"
    ) {
      const filterBySearch = dummyData.filter((item) => {
        return (
          item.city.includes(searchValues.country!) ||
          item.educationSystem.includes(searchValues.edusystem!)
        );
      });
      setFiltered(filterBySearch);
    }
    if (
      searchValues.country !== "كل المدن" ||
      searchValues.edusystem !== "كل الأنظمة" ||
      searchValues.edulevel !== "كل المراحل"
    ) {
      if (
        searchValues.country !== "كل المدن" &&
        searchValues.edusystem === "كل الأنظمة" &&
        searchValues.edulevel === "كل المراحل"
      ) {
        const filterBySearch = dummyData.filter((item) => {
          return item.city.includes(searchValues.country!);
        });
        setFiltered(filterBySearch);
      }
      if (
        searchValues.country !== "كل المدن" &&
        searchValues.edusystem !== "كل الأنظمة" &&
        searchValues.edulevel === "كل المراحل"
      ) {
        const filterBySearch = dummyData.filter((item) => {
          return (
            item.city.includes(searchValues.country!) ||
            item.educationSystem.includes(searchValues.edusystem!)
          );
        });
        setFiltered(filterBySearch);
      }
      if (
        searchValues.country !== "كل المدن" &&
        searchValues.edusystem !== "كل الأنظمة" &&
        searchValues.edulevel !== "كل المراحل"
      ) {
        const filterBySearch = dummyData.filter((item) => {
          return (
            item.city.includes(searchValues.country!) ||
            item.educationSystem.includes(searchValues.edusystem!) ||
            item.educationLevel.includes(searchValues.edulevel!)
          );
        });
        setFiltered(filterBySearch);
      }
      if (
        searchValues.country === "كل المدن" &&
        searchValues.edusystem !== "كل الأنظمة" &&
        searchValues.edulevel === "كل المراحل"
      ) {
        const filterBySearch = dummyData.filter((item) => {
          return item.educationSystem.includes(searchValues.edusystem!);
        });
        setFiltered(filterBySearch);
      }
      if (
        searchValues.country === "كل المدن" &&
        searchValues.edusystem === "كل الأنظمة" &&
        searchValues.edulevel !== "كل المراحل"
      ) {
        const filterBySearch = dummyData.filter((item) => {
          return item.educationLevel.includes(searchValues.edulevel!);
        });
        setFiltered(filterBySearch);
      }
    }
  };
  useEffect(() => {
    handleSearchSchools();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchValues]);
  return (
    <div className="flex flex-col gap-3">
      {filtered.length === 0 ? (
        <div className="flex flex-col items-center gap-16">
          <div className="flex flex-col items-center gap-[50px]">
            <img
              src="/assets/images/icon.svg"
              className="w-[180px] h-[180px] tablet:w-[150px] tablet:h-[150px] mobile:w-[128px] mobild:h-[128px]"
              alt=""
            ></img>
            <div className="flex flex-col gap-3 items-center">
              <p className="font-arMedium text-zinc900 text-3xl tablet:text-2xl mobile:text-[18px]">
                {t("resultsSchoolCard.component.unabletosearch")}
              </p>
              <p className="font-arMedium text-2xl tablet:text-xl mobile:text-base text-zinc500 w-[409px] tablet:w-[320px] mobile:w-[256px] text-center">
                {t("resultsSchoolCard.component.notmatching")}
              </p>
            </div>
          </div>
          {dummyData
            .sort(() => 0.5 - Math.random())
            .slice(0, 2)
            .map((item, index) => (
              <div key={index}>
                <SchoolCardResultsComponent
                  id={item.id}
                  schoolName={
                    i18n.language === "ar" ? item.schoolName : item.schoolNameEn
                  }
                  schoolDescription={
                    i18n.language === "ar"
                      ? item.description
                      : item.descriptionEn
                  }
                  imgUrl={item.images[0]}
                  studentsNumber={item.numberOfStudents.toString()}
                  country={
                    i18n.language === "ar" ? item.country : item.countryEn
                  }
                  city={i18n.language === "ar" ? item.city : item.cityEn}
                  district={
                    i18n.language === "ar" ? item.district : item.districtEn
                  }
                  startingPrice={item.price.toString()}
                  rating={item.rating}
                />
              </div>
            ))}
        </div>
      ) : (
        <>
          {filtered.map((item, index) => (
            <div key={index}>
              <SchoolCardResultsComponent
                id={item.id}
                schoolName={
                  i18n.language === "ar" ? item.schoolName : item.schoolNameEn
                }
                schoolDescription={
                  i18n.language === "ar" ? item.description : item.descriptionEn
                }
                imgUrl={item.images[0]}
                studentsNumber={item.numberOfStudents.toString()}
                country={i18n.language === "ar" ? item.country : item.countryEn}
                city={i18n.language === "ar" ? item.city : item.cityEn}
                district={
                  i18n.language === "ar" ? item.district : item.districtEn
                }
                startingPrice={item.price.toString()}
                rating={item.rating}
              />
            </div>
          ))}
        </>
      )}
    </div>
  );
}

export default SchoolCardResultsContainer;
